module.exports = __webpack_public_path__ + "img/warning.6fe9a592.svg";